import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";

const ToothFairySearch = ({ children }) => {
  const { currentTheme } = AppTheme.useTheme();

  return (
    <View
      style={{
        // backgroundColor: currentTheme?.theme?.softBackgroundColor,
        marginTop: 10,
        borderRadius: 5,
      }}
    >
      <View>{children}</View>
    </View>
  );
};

export default ToothFairySearch;
